import React, { useEffect } from "react";

export default function Franchise() {
  useEffect(() => {
    window.location.replace("https://fr.energo.app");
  }, []);

  return <></>;
}
